<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_mg_headline}}</h3>
    {{bergWetterbericht?.wx_mg_headline}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_bavaria_mg}}</h3>
    {{bergWetterbericht?.wx_bavaria_mg}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_next_days_mg}}</h3>
    {{bergWetterbericht?.wx_next_days_mg}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_alps_headline}}</h3>
    {{bergWetterbericht?.wx_alps_headline}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_bavaria_alps}}</h3>
    {{bergWetterbericht?.wx_bavaria_alps}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_next_days_alps}}</h3>
    {{bergWetterbericht?.wx_next_days_alps}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_austria_headline}}</h3>
    {{bergWetterbericht?.wx_austria_headline}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_austria_italy}}</h3>
    {{bergWetterbericht?.wx_austria_italy}}
  </div>
  <div class="bericht-text-container">
    <h3>{{bergWetterbericht?.caption_wx_next_days_austria}}</h3>
    {{bergWetterbericht?.wx_next_days_austria}}
  </div>
  <div class="bericht-text-container">
    {{bergWetterbericht?.footer}}
  </div>
</div>
